import { useMemo } from 'react';
import { fieldMappingSelector } from 'slices/field.slice';
/// Slices
import { selectObjectTypesList } from 'slices/objectTypes.slice';
import { useAppSelector } from 'slices/store';
import { EFieldType } from '@timeedit/types/lib/enums';
import type { TReservationTemplate, TType } from '@timeedit/types/lib/types';
/// Types
/// Components
import { TEInput } from '@timeedit/ui-components';
/// Styles
import './TemplateCapRes.scss';

interface CapResConfigurationProps {
  template: TReservationTemplate;
  onChange: (key: string, value: any) => void;
}

const TREE_SELECT_FIELDS = [
  { label: 'Capacity source', key: 'objectCapacityFieldId' },
  { label: 'Primary size source', key: 'objectSizeFieldId' },
  { label: 'Secondary size source', key: 'objectSizeSecondFieldId' },
] as const;

const CapResConfiguration = (props: CapResConfigurationProps) => {
  const { template } = props;
  const objectTypes: TType[] = useAppSelector(selectObjectTypesList);
  const fields = useAppSelector(fieldMappingSelector);

  const objectTypeTree = useMemo(() => {
    return objectTypes
      .map((type) => {
        return {
          value: `type__${type.id}`,
          label: type.name,
          disabled: true,
          children: type.fields
            .filter(
              (field) =>
                fields?.[field]?.id &&
                fields?.[field]?.fieldType === EFieldType.INTEGER
            )
            .map((field) => ({
              label: fields?.[field]?.name,
              // ensure duplicated id between type and field
              value: `field__${type.id}__${fields?.[field]?.id}`,
            })),
        };
      })
      .filter((type) => type.children.length > 0);
  }, [objectTypes, fields]);

  const onTypeChange = (value: string, key: string) => {
    if (!value) {
      props.onChange(key, 0);
      return;
    }
    const fieldId = value.split('__').pop();
    props.onChange(key, Number(fieldId));
  };

  const fieldValueMap = useMemo(() => {
    const map = new Map<number, string>();
    for (const type of objectTypeTree) {
      for (const child of type.children) {
        const id = Number(child.value.split('__').pop());
        if (id) map.set(id, child.value);
      }
    }
    return map;
  }, [objectTypeTree]);

  return (
    <div className="move-reservations">
      {TREE_SELECT_FIELDS.map(({ label, key }) => (
        <TEInput.TreeSelect
          key={key}
          flow="column"
          label={label}
          treeDefaultExpandAll
          popupMatchSelectWidth={false}
          wrapperStyle={{ width: '170px' }}
          style={{ width: '100%' }}
          treeData={objectTypeTree}
          value={fieldValueMap.get(template[key])}
          onChange={(value: string) => onTypeChange(value, key)}
        />
      ))}
    </div>
  );
};

export default CapResConfiguration;
